<template>
    <div class="f-topic-header">
        <div class="f-topic-header-router">
            <router-link class="f-topic-header-router-name" to="/">首页</router-link>
            <span class="f-topic-header-router-arrow">></span>
            <a class="f-topic-header-router-name" @click="toBoard">
                {{boardInfo.name}}
            </a>
            <span class="f-topic-header-router-arrow">></span>
            <a class="f-topic-header-router-name">帖子正文</a>
        </div>

        <div class="f-topic-header-info">
            <avatar class="f-topic-header-info-avatar"
                :user-info="authorInfo"></avatar>
            <div class="f-topic-header-info-topic">
                <div class="f-topic-header-info-topic-title">
                    <h1 class="f-topic-header-info-topic-title-name">{{topicInfo.title}}</h1>
                    <top-icon v-if="topicInfo.isStick"
                        class="f-topic-header-info-topic-label"></top-icon>
                    <elite-icon v-if="topicInfo.isElite"
                        class="f-topic-header-info-topic-label"></elite-icon>
                </div>
                <div class="f-topic-header-info-topic-info">
                    <nick-name class="f-topic-header-info-username"
                        :user-info="authorInfo"></nick-name>
                    <img v-if="authorInfo.isOfficial"
                        :src="verify"
                        class="f-topic-header-info-official">
                    <span class="f-topic-header-info-other">·</span>
                    <span class="f-topic-header-info-time">
                        发布于{{topicInfo.createdTime}}
                    </span>
                    <span class="f-topic-header-info-other">·</span>
                    <span class="f-topic-header-info-aside">
                        <span class="f-topic-header-info-num">
                            {{viewCount}}浏览
                        </span>
                        <span class="f-topic-header-info-num">
                            {{replyCount > 9999 ? '9999+' : replyCount}}{{boardInfo.id === 1 ? '回答' : '回复'}}
                        </span>
                    </span>
                </div>
            </div>
            <div class="f-topic-header-info-right">
                <!-- 普通用户的编辑 -->
                <edit-icon v-if="canEditTopic"
                    @edit="toEdit"></edit-icon>
                <!-- 普通用户的删除权限 -->
                <delete-icon
                    v-if="canEditTopic && !hasSystemPermission"
                    del-type="topic"
                    @topicDel="delTopic">
                </delete-icon>
                <!-- 点赞 -->
                <evaluate-icon class="f-topic-header-info-liked"
                    like-type="topic"
                    :is-evaluated="isEvaluated"
                    :evaluation-count="evaluationCount"
                    @topicEva="changeTopicLikeState">
                </evaluate-icon>

                <!--文章、问答保留系统管理员功能操作-->
                <manager-operation
                    v-if="hasSystemPermission"
                    class="f-topic-header-info-manager"
                    :topicid="topicInfo.topicId"
                    :isstick="topicInfo.isStick"
                    :iselite="topicInfo.isElite"
                    :isbanned="authorInfo.isBanned"
                    @refreshlist="refreshList">
                </manager-operation>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/topic-header.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';
import {limitMaxNum} from '@/utils/matchFilter';

import Topping from '@/components/Topping.vue';
import Elite from '@/components/Elite.vue';
import EvaluateIcon from './icon/EvaluateIcon';
import DeleteIcon from './icon/DeleteIcon';
import EditIcon from './icon/EditIcon';
import ManagerOperation from '@/components/ui-icon/manager-operation';
import NickName from '@/components/NickName';
import Avatar from '@/components/Avatar';

export default {
    data() {
        return {
            verify: require('../../../assets/images/icon-official.png')
        };
    },
    components: {
        'top-icon': Topping,
        'elite-icon': Elite,
        'evaluate-icon': EvaluateIcon,
        'delete-icon': DeleteIcon,
        'edit-icon': EditIcon,
        'manager-operation': ManagerOperation,
        'nick-name': NickName,
        'avatar': Avatar
    },
    computed: {
        ...mapState({
            topicInfo: state => state.topicContent.topicData.topicInfo,
            replyCount: state => state.topicContent.topicData.topicInfo.replyCount,
            boardInfo: state => state.topicContent.topicData.boardInfo,
            authorInfo: state => state.topicContent.topicData.authorInfo,
            isEvaluated: state => state.topicContent.topicData.isEvaluated
        }),
        ...mapGetters([
            'hasSystemPermission',
            'canEditTopic'
        ]),
        viewCount: {
            get() {
                return limitMaxNum(this.topicInfo.viewCount);
            }
        },
        evaluationCount: {
            get() {
                return limitMaxNum(this.topicInfo.evaluationCount);
            }
        }
    },
    methods: {
        toBoard() {
            this.$emit('toBoard');
        },
        toEdit() {
            if (this.$store.state.header.isLogin) {
                if (this.$store.state.header.isBanned) {
                    toast.error(Tip.banned);
                }
                else {
                    _hmt.push(['_trackEvent', 'operation', '编辑按钮点击']);
                    this.$router.push({name: 'editTopic', params: this.$route.params});
                }
            }
            else {
                this.$store.dispatch('navToPassport');
            }
        },
        changeTopicLikeState() {
            this.$emit('changeTopicLikeState');
        },
        refreshList(type) {
            if (type === 'delete') {
                this.toBoard();
            }
            else {
                let topicId = this.topicInfo.topicId;
                let topicType = this.topicInfo.topicType;
                this.$store.dispatch('getTopicContent', {id: topicId, type: topicType});
            }
        },
        delTopic() {
            this.$emit('del', {type: 'delete'});
        }
    }
};
</script>

